import { render, staticRenderFns } from "./bpb-nav-toc.vue?vue&type=template&id=3b3e903a&"
import script from "./bpb-nav-toc.vue?vue&type=script&lang=js&"
export * from "./bpb-nav-toc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports